export default "__VITE_ASSET__Bp_8wWB6__"